import * as yup from "yup";
import {
  DaysOfWeek,
  EventDurationMetric,
  EventType,
  RecurringPeriodType,
} from "../../../../../common/enums";
import { requiredField } from "../../../../../common/infrastructure/helpers/yupHelper";

export const serviceWizardFormSchema = yup
  .object({
    id: yup.number().optional().defined(),
    studioId: yup.number().required().defined(),
    serviceId: yup.number().required(requiredField("Услуга")).defined(),
    employeeId: yup.number().required(requiredField("Служител")).defined(),
    userId: yup.number().required(requiredField("Клиент")).defined(),
    date: yup
      .date()
      .typeError("Моля изберете валидни дата и час.")
      .required(requiredField("Дата и час"))
      .defined(),
    durationInMinutes: yup.number().required(requiredField("Продължителност")).defined(),
    price: yup
      .number()
      .min(0, "Цената не може да бъде отрицателна")
      .required(requiredField("Цена"))
      .defined(),
    isMultisportAvailable: yup.boolean().default(false).defined(),
    isCoolFitAvailable: yup.boolean().default(false).defined(),
    forceEmailNotifications: yup.boolean().default(true).defined(),
    type: yup.mixed().required().defined(),

    // Recurring validation
    isRecurring: yup.boolean().default(false).defined(),
    recurringDays: yup
      .array()
      .of(yup.number())
      .when("isRecurring", {
        is: true,
        then: (schema) =>
          schema.min(1, "Моля изберете поне един ден от седмицата"),
        otherwise: (schema) => schema.optional(),
      })
      .defined(),
    recurringPeriod: yup
      .number()
      .when("isRecurring", {
        is: true,
        then: (schema) =>
          schema
            .min(1, "Периодът трябва да бъде поне 1")
            .required(requiredField("Период"))
            .when("recurringPeriodType", {
              is: RecurringPeriodType.Months,
              then: (schema) =>
                schema.max(3, "Периодът не може да бъде повече от 3 месеца"),
              otherwise: (schema) =>
                schema.max(12, "Периодът не може да бъде повече от 12 седмици"),
            }),
        otherwise: (schema) => schema.optional(),
      })
      .defined(),
    recurringPeriodType: yup
      .number()
      .when("isRecurring", {
        is: true,
        then: (schema) => schema.required(requiredField("Период")),
        otherwise: (schema) => schema.optional(),
      })
      .defined(),
    recurringInterval: yup
      .number()
      .when("isRecurring", {
        is: true,
        then: (schema) =>
          schema
            .min(1, "Интервалът трябва да бъде поне 1")
            .required(requiredField("Интервал"))
            .max(24, "Интервалът не може да бъде повече от 24"),
        otherwise: (schema) => schema.optional(),
      })
      .defined(),
    recurringIntervalType: yup
      .number()
      .when("isRecurring", {
        is: true,
        then: (schema) => schema.required(requiredField("Тип интервал")),
        otherwise: (schema) => schema.optional(),
      })
      .defined(),
    applyChangeToAllFutureEvents: yup.boolean().optional().defined(),
    sendUpdateEmail: yup.boolean().optional().defined(),
  })
  .required();

export type IServiceWizardFormModel = yup.InferType<
  typeof serviceWizardFormSchema
>;

export const serviceWizardFormDefaultValues: IServiceWizardFormModel = {
  id: 0,
  studioId: 0,
  serviceId: 0,
  employeeId: 0,
  userId: 0,
  date: undefined,
  durationInMinutes: EventDurationMetric.OneHour,
  price: 0,
  isMultisportAvailable: false,
  isCoolFitAvailable: false,
  forceEmailNotifications: false,
  type: EventType.Service,
  isRecurring: false,
  recurringDays: [DaysOfWeek.Monday],
  recurringPeriod: 1,
  recurringInterval: 1,
  recurringPeriodType: RecurringPeriodType.Months,
  recurringIntervalType: RecurringPeriodType.Weeks,
  applyChangeToAllFutureEvents: false,
  sendUpdateEmail: false,
};
